import { useState, useEffect } from 'react'
import { FLAVOR } from '../flavor/flavor'
import styles from './InstallBanner.module.css'

// Detect iOS Safari standalone mode
function isInStandaloneMode(): boolean {
  return (
    'standalone' in window.navigator &&
    (window.navigator as { standalone?: boolean }).standalone === true
  )
}

function isIOSSafari(): boolean {
  const ua = navigator.userAgent
  return /iP(hone|ad|od)/.test(ua) && /Safari/.test(ua) && !/CriOS|FxiOS/.test(ua)
}

export function InstallBanner() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    // Show only in iOS Safari, only if not already installed
    if (isIOSSafari() && !isInStandaloneMode()) {
      const dismissed = sessionStorage.getItem('pfh-install-dismissed')
      if (!dismissed) setShow(true)
    }
  }, [])

  if (!show) return null

  return (
    <div className={styles.banner} role="complementary" aria-label="Install app">
      <div className={styles.text}>
        <strong>Install {FLAVOR.appName}</strong> — tap{' '}
        <span className={styles.shareIcon} aria-label="Share button">⎙</span>{' '}
        then <em>Add to Home Screen</em>
      </div>
      <button
        className={styles.dismiss}
        onClick={() => {
          sessionStorage.setItem('pfh-install-dismissed', '1')
          setShow(false)
        }}
        aria-label="Dismiss install prompt"
      >
        ✕
      </button>
    </div>
  )
}
